module.exports = function (app) {
	'use strict';

	require('./subscriber')(app);
	require('./otherInsurance')(app);
	require('./medicare')(app);
	require('./mnloa')(app);
	require('./coverage')(app);
	require('./majorMedical')(app);
	require('./reviewSubmit')(app);


	var runOnceDenySteps;
	app.controller('pages.employee.add', ['$state', '$scope', 'addFlowCommander', 'storage', 'employee',
		function ($state, $scope, addFlowCommander, storage, employee) {

			if (employee.editInProgress.isActive()) {
				employee.editInProgress.reset();
			}

			if ($state.params.subscriberId) {  // This was here for returning from provider search, but is no longer used.  Keeping this now as a developer convenience, to quickly refresh applications
				addFlowCommander.enrollmentInProcess.resume($state.params.subscriberId);
			}

			var providerReturnSubscriberId = storage.get('providerReturnSubscriberId');

			// Sidebar is dumb, and redirects the initial load of /coverage back to /subscriber.
			// We then redirect back to /coverage below, but the coverage page has already loaded, so the directives have fired and cleared any storage that we needed
			// Sooooo, make this page the governer of the stored data, and then restore it in a new name, so coverage will still have a copy

			if (providerReturnSubscriberId) {
				addFlowCommander.sidebar.links[0].approved = true; // hack to stop sidebar from redirectiong us to hell
				storage.del('providerReturnSubscriberId');
				employee.loadEnrollment(providerReturnSubscriberId).then(
					function(employee) {
						addFlowCommander.sidebar.update();
						addFlowCommander.enrollmentInProcess.getFirstIncompleteStep(employee);
						addFlowCommander.denyCurrentStep();
					}
				);
				var runOnceSubscriberSSN = $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options){ // jshint ignore: line
					toParams.subscriberSSN = providerReturnSubscriberId;
					runOnceSubscriberSSN();
				});
			}
			if (runOnceDenySteps) {
				runOnceDenySteps();
			}
			runOnceDenySteps = $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams, options){ // jshint ignore: line
				if (toState && toState.name && toState.name.indexOf('employee.add.') == 0) {
					addFlowCommander.denyCurrentStep();
				}
			});

			$scope.employeeAlias = employee; // please do NOT change this name
			$scope.sidebar = addFlowCommander.sidebar;

			(function setBreadCrumbs() {
				var crumbs = {
					add: {
						title: 'Add Employee',
						state: 'employee.add'
					},
					enrollment: {
						title: 'Enrollment',
						state: 'employee.enrollment'
					},
					enrollmentsInProcess: {
						title: 'Enrollments In Process',
						state: 'employee.enrollmentsInProcess'
					}
				};

				var breadCrumb = $scope.sidebar.breadCrumb = {};

				switch ($state.previous.name) {
					case 'employee.enrollment':
						breadCrumb.primary = crumbs.enrollment;
						breadCrumb.secondary = crumbs.add;
					break;
					case 'employee.enrollmentsInProcess':
						breadCrumb.primary = crumbs.enrollment;
						breadCrumb.secondary = crumbs.enrollmentsInProcess;
						breadCrumb.tertiary = crumbs.add;
					break;
					default:
						breadCrumb.primary = crumbs.add;
				}
			}());
		}
	]);


	return [
		{
			state: 'employee.add',
			url: '/add',
			postPassword: true,
			views: {
				'body@': {
					templateUrl: 'manage-employees/add/subscriber.employerTemplate.html/pages/employee/add/add',
					controller: 'pages.employee.add'
				}
			},
			params: { subscriberSSN: '' }
		},
		{
			state: 'employee.add.subscriber',
			url: '/subscriber',
			postPassword: true,
			views: {
				'content@employee.add': {
					templateUrl: 'manage-employees/add/subscriber.employerTemplate.html/pages/employee/add/subscriber',
					controller: 'pages.employee.add.subscriber'
				}
			},
			reloadOnSearch: false,
			params: { umi: '', reinstateDate: '' }
		},
		{
			state: 'employee.add.coverage',
			url: '/coverage?subscriberId&PCPNumber&PCPNAME&PCPIndex',
			postPassword: true,
			views: {
				'content@employee.add': {
					templateUrl: 'manage-employees/add/coverage.employerTemplate.html/pages/employee/add/coverage',
					controller: 'pages.employee.add.coverage'
				}
			}
		},
		{
			state: 'employee.add.majorMedical',
			url: '/major-medical',
			postPassword: true,
			views: {
				'content@employee.add': {
					templateUrl: 'manage-employees/add/major-medical.employerTemplate.html/pages/employee/add/majorMedical',
					controller: 'pages.employee.add.majorMedical'
				}
			}
		},
		{
			state: 'employee.add.otherInsurance',
			url: '/other-insurance',
			postPassword: true,
			views: {
				'content@employee.add': {
					templateUrl: 'manage-employees/add/other-insurance.employerTemplate.html/pages/employee/add/otherInsurance',
					controller: 'pages.employee.add.otherInsurance'
				}
			}

		},
		{
			state: 'employee.add.medicare',
			url: '/medicare',
			postPassword: true,
			views: {
				'content@employee.add': {
					templateUrl: 'manage-employees/add/medicare.employerTemplate.html/pages/employee/add/medicare',
					controller: 'pages.employee.add.medicare'
				}
			}
		},
		{
			state: 'employee.add.mnloa',
			url: '/mnloa',
			postPassword: true,
			views: {
				'content@employee.add': {
					templateUrl: 'manage-employees/add/mnloa.employerTemplate.html/pages/employee/add/mnloa',
					controller: 'pages.employee.add.mnloa'
				}
			}
		},
		{
			state: 'employee.add.reviewSubmit',
			url: '/review-submit',
			postPassword: true,
			views: {
				'content@employee.add': {
					templateUrl: 'manage-employees/add/review-submit.employerTemplate.html/pages/employee/add/reviewSubmit',
					controller: 'pages.employee.add.reviewSubmit'
				}
			}
		}
	];
};
